/**
 * Internal dependencies
 */
import objectPick from '../../../../utils/objectPick';

export default function getSelectedFont(fontObj, family) {
  return {
    family,
    ...objectPick(fontObj, [
      'service',
      'fallbacks',
      'weights',
      'styles',
      'variants',
      'metrics',
      'fsSelection',
      'useTypoMetrics',
      'url',
      'urls',
      'sourceId',
    ]),
  };
}
